import { useEffect, useState } from 'react';

import styled from '@emotion/styled';

const PaymentSuccessful = () => {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const interval = window.setInterval(() => {
      setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    const timeout = window.setTimeout(() => {
      window.clearInterval(interval);
      window.parent.postMessage(
        {
          source: 'logirate-paystack',
          type: 'PAYMENT_COMPLETED',
        },
        '*',
      );
    }, 5000);

    return () => {
      window.clearInterval(interval);
      window.clearTimeout(timeout);
    };
  }, []);

  return (
    <Container>
      <SuccessCard>
        <PulseRing aria-hidden='true' />
        <CheckIcon aria-hidden='true'>✓</CheckIcon>
        <Title>Payment Successful</Title>
        <Description>
          Logirate is processing your payment — your lookup balance will reflect
          in just a moment.
          <br />
          <Countdown>
            {countdown > 0
              ? `Updating your account… ${countdown}s`
              : 'All done! Redirecting you now ✓'}
          </Countdown>
        </Description>
      </SuccessCard>
    </Container>
  );
};

export default PaymentSuccessful;

const Container = styled.div`
  display: grid;
  place-items: center;
  height: 100vh;
  width: 100%;
  padding: 24px;
  /* this is were to add color in future */
  background: transparent;
`;

const SuccessCard = styled.div`
  width: min(420px, 100%);
  padding: 36px 28px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 24px 60px rgba(9, 57, 128, 0.16);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  text-align: center;
  animation: card-in 500ms ease-out both;

  @keyframes card-in {
    from {
      opacity: 0;
      transform: translateY(14px) scale(0.98);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`;

const PulseRing = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 999px;
  background: linear-gradient(135deg, #3b7cf4, #5ec2ff);
  opacity: 0.18;
  animation: pulse-ring 1.7s ease-out infinite;

  @keyframes pulse-ring {
    0% {
      transform: scale(0.75);
      opacity: 0.28;
    }
    70% {
      transform: scale(1.2);
      opacity: 0;
    }
    100% {
      transform: scale(1.2);
      opacity: 0;
    }
  }
`;

const CheckIcon = styled.div`
  width: 76px;
  height: 76px;
  margin-top: -88px;
  border-radius: 999px;
  background: linear-gradient(135deg, #1a8f4a, #22c55e);
  color: #ffffff;
  display: grid;
  place-items: center;
  font-size: 42px;
  font-weight: 700;
  box-shadow: 0 14px 30px rgba(34, 197, 94, 0.35);
  animation: pop-in 600ms cubic-bezier(0.2, 1.1, 0.2, 1) both;

  @keyframes pop-in {
    from {
      transform: scale(0.4);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

const Title = styled.h1`
  margin: 6px 0 0;
  font-size: 27px;
  line-height: 1.2;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;

const Description = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;

const Countdown = styled.span`
  display: inline-block;
  margin-top: 8px;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.primaryTextColor};
  letter-spacing: 0.02em;
  animation: tick 1s ease-in-out infinite;

  @keyframes tick {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
`;
